import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

import EstaSeguro from '../../components/funcionales/estaseguro'

//utils
import queries from '../../utils/queries'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.porcImpto} dato2={props.elemento.descrImpto} value={props.elemento.codigoImpto}>{props.elemento.descrImpto} ={">"} {props.elemento.porcImpto}%</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="impto" id="miLista" value={permiteUpdate?argsDocum.codigoImpto?argsDocum.codigoImpto:"":idLista.codigoImpto?idLista.codigoImpto:""} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">No tiene impuesto</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1Cl = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento.descrClaseServ}>{props.elemento.descrClaseServ}</option>
  )
};

const ListaCl = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1Cl elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="claseserv" id="miLista1" value={permiteUpdate?argsDocum.descrClaseServ:idLista.descrClaseServ} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerOtpa2 extends React.Component {
  state={
    argsDocum: {descrOtrosPagCl: this.props.idLista.descrOtrosPagCl,
                codigoImpto: this.props.idLista.codigoImpto,
                descrImpto: this.props.idLista.descrImpto,
                porcImpto: this.props.idLista.porcImpto,
                descrClaseServ: this.props.idLista.descrClaseServ,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name === "impto"){
        let miLista = document.getElementById("miLista");
        argsDocum['codigoImpto'] = miLista.options[miLista.selectedIndex].value
        argsDocum['porcImpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
        if(miLista.options[miLista.selectedIndex].text==="No tiene impuesto"){
          argsDocum['descrImpto'] = "No tiene impuesto"
        }else{
          argsDocum['descrImpto'] = miLista.options[miLista.selectedIndex].attributes[1].value
        }
      }else{
        if(ev.target.name === "claseserv"){
          let miLista = document.getElementById("miLista1");
          argsDocum['codigoClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsDocum['descrClaseServ'] = miLista.options[miLista.selectedIndex].text
        }else{
          argsDocum[ev.target.name] = ev.target.value 
        }
      }
      this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => {
      var btnPress = await ev.target.attributes[0].value
      if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
      if(btnPress==="No"){
          this.setState({open: false})
      };
      if(btnPress==="Si"){
          this.setState({confirmaAct: true})
          this.setState({open: false})
          const myBtn = await document.getElementById("btnUpdDel");
          myBtn.click()
      }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    // console.log(this.props.list)
    let listaCScl = []
    if(this.props.data.allClasesServ){listaCScl = this.props.data.allClasesServ}

    // console.log("entro ver")
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Concepto de otros pagos del cliente
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Concepto</label>
                    <Form.Input autoComplete="off" name="descrOtrosPagCl" id="descrOtrosPagCl" value={this.props.permiteUpdate?argsDocum.descrOtrosPagCl:this.props.idLista.descrOtrosPagCl} onChange={this.handleChange} placeholder='Concepto' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrOtrosPagCl'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Impuesto</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Clase</label>
                    <ListaCl list={listaCScl} styles={this.props.styles} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default graphql(queries.query.allClasesServ)(VerOtpa2)
